/**
 * Tax codes — what a VAT line names so the TT-03a return can be built from
 * the ledger by code rather than by guessing from the account (docs/22 §7).
 */
import { decimalFromInt } from "../money/decimal.js";
export function taxCodeTable(codes) {
    return new Map(codes.map((code) => [code.code, code]));
}
const pct = (n) => decimalFromInt(n);
/** The starter set. Reverse charge is accrued on foreign SaaS and ads, not ignored (docs/22 §7). */
export const STANDARD_TAX_CODES = taxCodeTable([
    { code: "VAT10", name: { mn: "НӨАТ 10%", en: "Output VAT 10%" }, rate: pct(10), kind: "output" },
    { code: "VAT10-IN", name: { mn: "Орлогын НӨАТ 10%", en: "Input VAT 10%" }, rate: pct(10), kind: "input" },
    { code: "VAT0", name: { mn: "НӨАТ 0%", en: "Zero-rated" }, rate: pct(0), kind: "zero" },
    { code: "EXEMPT", name: { mn: "НӨАТ-аас чөлөөлөгдсөн", en: "Exempt" }, rate: pct(0), kind: "exempt" },
    { code: "RC10", name: { mn: "Урвуу НӨАТ 10%", en: "Reverse charge 10%" }, rate: pct(10), kind: "reverse_charge" },
]);
//# sourceMappingURL=tax-code.js.map